import {
  ExploreInsightCondition,
  ExploreInsightDirection,
} from '@toggle/toggle';
import clsx from 'clsx';
import React, { SyntheticEvent } from 'react';

import { APP_BASE_PATH } from '~/routes/app-paths';

import { InsightIcons } from '../insight-icons/InsightIcons';
import { getInsightIconColorAndDirection } from '../insight-icons/utils';
import styles from './InsightIconsRoot.module.scss';

export interface InsightIconsRootProps {
  conditions: ExploreInsightCondition[];
  direction: ExploreInsightDirection;
  isStarred: boolean;
  customSize?: { width: string; height: string };
  isCombined?: boolean;
  isMatched?: boolean;
  layout?: 'vertical' | 'horizontal';
  isSparklesCondensed?: boolean;
  onIconClick?: (e: SyntheticEvent) => void;
}

export const InsightIconsRoot = ({
  conditions,
  direction,
  isStarred,
  customSize,
  isCombined = false,
  isMatched = true,
  layout,
  isSparklesCondensed,
  onIconClick,
}: InsightIconsRootProps) => {
  if (isCombined) {
    const { names, style, iconDirection } = getInsightIconColorAndDirection({
      conditions,
      matched: isMatched,
      direction,
      layout,
    });

    return (
      <div
        className={clsx(
          styles.insightIconsWrapper,
          isMatched && styles.insightIconsWrapperInteractive
        )}
        data-testid="insight-icons-root"
        onClick={onIconClick}
      >
        {isStarred && (
          <img
            alt=""
            className={styles.styledImg}
            data-testid="sparkles-svg"
            height={isSparklesCondensed ? 6 : 12}
            src={`${APP_BASE_PATH}/static/images/icons/sparkles.svg`}
            width={isSparklesCondensed ? 6 : 12}
          />
        )}
        <InsightIcons
          iconNames={names}
          variant={style}
          direction={iconDirection}
          customSize={customSize}
        />
      </div>
    );
  }

  return (
    <>
      {conditions.map((condition, index) => {
        const { names, style, iconDirection } = getInsightIconColorAndDirection(
          {
            conditions,
            matched: isMatched,
            direction,
            layout: undefined,
          }
        );
        return (
          <div
            className={clsx(
              styles.insightIconsWrapper,
              isMatched && styles.insightIconsWrapperInteractive
            )}
            data-testid="insight-icons-root"
            key={`${condition.method}-${index}`}
            onClick={onIconClick}
          >
            {isStarred && (
              <img
                alt=""
                className={styles.styledImg}
                data-testid="sparkles-svg"
                height={isSparklesCondensed ? 6 : 12}
                src={`${APP_BASE_PATH}/static/images/icons/sparkles.svg`}
                width={isSparklesCondensed ? 6 : 12}
              />
            )}
            <InsightIcons
              iconNames={names}
              variant={style}
              direction={iconDirection}
              customSize={customSize}
            />
          </div>
        );
      })}
    </>
  );
};
